import React from "react";
import { Helmet } from "react-helmet";
import { MerchTeaser } from "../../../sections/MerchTeaser/MerchTeaser";
import './ProductList.scss';

const ProductList = () => {
    return (
        <>
            <Helmet>
                <title>Lembawe9 - Merch</title>
                <meta 
                    name="description" 
                    content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect." 
                />
            </Helmet>
            <main>
                <MerchTeaser />
            </main>
        </>
    )
}
export default ProductList;